import React, {useState, useEffect} from "react";
import './PersonalInfo.css';
import Header from "./Header";
import { useAuth0 } from "@auth0/auth0-react";
import BaseContainerDividingLineRHSSidebar from "./BaseContainerDividingLineRHSSidebar";
import rect6518 from "../img/rectangle-6518@2x.svg"
import Salary from "./Salary";
import EditProfileFirstName from "./EditProfileFirstName";
import EditProfileLastName from "./EditProfileLastName";
import EditProfileEmail from "./EditProfileEmail";
import EditProfileDOB from "./EditProfileDOB";
import CountryDropdown from "./CountryDropdown";
import EditProfileProvinceState from "./EditProfileProvinceState";
import EditProfileMaritalStatus from "./EditProfileMaritalStatus";
import EditProfileButton from "./EditProfileButton";
import ChangePlanButton from "./ChangePlanButton";
import NotificationsButton from "./NotificationsButton";
import PasswordAndSecurityButton from "./PasswordAndSecurityButton";
import axios from "axios";
import editLogo from "../img/vector-5@2x.svg";


const PersonalInfo = () => {
    const [saving, setSaving] = useState(false);
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [DateOfBirth, setDOB] = useState("");
    const [Country, setCountry] = useState("");
    const [Province, setProvince] = useState("");
    const [MaritalStatus, setMarStatus] = useState("");

    const { user } = useAuth0();


    // useEffect (() => {
    //     axios.get('http://http://localhost:4000/USERS').then(res => )
    // })

    // const addUser = () => {
    //     setSaving(true);
    //     axios.get('http://localhost:4000/USERS/add?UserID=100000&FirstName="Test"&LastName="User"&Email="max.jessome@oltrefinancial.com"&Country="Canada"&Province="NS"&MaritalStatus="Divorced"').then(() => 
    //     setSaving(false));
    // }

    function getFirstName(nameOne){
        setFirstName(nameOne);
        return nameOne;
    }

    function getLastName(lastNameOne){
        setLastName(lastNameOne);
        return lastNameOne;
    }

    function getEmail(emailValue){
        setEmail(emailValue);
        return emailValue;
    }

    function getDOB(DOBValue){
        setDOB(DOBValue);
        return DOBValue;
    }

    function getCountry(country){
        setCountry(country);
        return country;
    }

    function getProvince(province){
        setProvince(province);
        return province;
    }

    function getMaritalStatus(marStatus){
        setMarStatus(marStatus);
        return marStatus;
    }

    const submitHandler = (e) => {
        e.preventDefault();
        // setSaving(true)
        // const UserID = 78932
        console.log(FirstName, LastName, Email, DateOfBirth, Country, Province, MaritalStatus)
        axios.get(`http://localhost:4000/USERS/add?UserID=${user.sub}&FirstName=${FirstName}&LastName=${LastName}&Email=${Email}&DateOfBirth=${DateOfBirth}&Country=${Country}&Province=${Province}&MaritalStatus=${MaritalStatus}`)
            .then(response => {
                console.log(response)
                // setSaving(false);
            })
            .catch(error => {
                console.log(error)
            })
    }


    return(
        <div className="container-center-horizontal">
            <div className="profile-home-page screen">
                <div className="flex-col-28">
                    <Header />
                    <div className="overlap-group4-3">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="rectangle-6452-5 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6457-3 border-1px-athens-gray-2"></div>
                        <Salary></Salary>
                        <img className="rectangle-6518-1" src={rect6518} />
                        <div className="profile nunito-bold-black-30px">Profile</div>
                        <form onSubmit={submitHandler}>
                            <div className="group-1000004872">
                                <EditProfileFirstName getFirstNameData={getFirstName} />
                                <EditProfileLastName getLastNameData={getLastName} />
                                <div className="group-1000004868"></div>
                            </div>
                            <div className="group-1000004941">
                                <EditProfileEmail getEmailData={getEmail} />
                                <EditProfileDOB getDOBData={getDOB} />
                            </div>
                            <CountryDropdown getCountryData={getCountry} />
                            <EditProfileProvinceState getProvinceData={getProvince} />
                            <EditProfileMaritalStatus getStatusData={getMaritalStatus} />
                            <button type="submit" className="save-button">Save</button>
                        </form>
                        <EditProfileButton className="nunito-bold-azure-radiance-14px" logo={editLogo} />
                        <ChangePlanButton />
                        <PasswordAndSecurityButton />
                        <NotificationsButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalInfo;